<app-training-block
  contentType="coaching"
  [trainingForm]="trainingBlockFormGroup"
  [mediaForm]="mediaBlockFormGroup"
/>
<app-information-block contentType="coaching" [informationForm]="informationBlockFormGroup" />
<app-recommendation-block
  contentType="coaching"
  [recommendationForm]="recommendationBlockFormGroup"
/>
<app-publication-block contentType="coaching" [publicationForm]="publicationBlockFormGroup" />
